import axios from "../axios/index.js";

const urlGetProductList = "/api/product/get-list";
const urlCreateProduct = "/api/product/create";
const urlUpdateProduct = "/api/product/update/";
const urlGetProductSlug = "/api/product/check-slug";
const urlGetProductDetail = "/api/product/detail/";
const urlReviewProductDetail = "/api/product/review/";
const urlDeleteProduct = "/api/product/delete/";

export default {
    getList(params) {
        return axios.get(urlGetProductList, { 
            params: params
        });
    },

    getDetail(id) {
        return axios.get(urlGetProductDetail + id);
    },

    review(id) {
        return axios.get(urlReviewProductDetail + id);
    },

    create(params, config) {
        return axios.post(urlCreateProduct, params, config);
    },

    update(id, params, config) {
        return axios.post(urlUpdateProduct + id, params, config);
    },

    getSlug(params) {
        return axios.post(urlGetProductSlug, params);
    },

    delete(id) {
        return axios.post(urlDeleteProduct + id, id);
    },
};
